import {
  useStore,
  useStoreProps
} from "./USB5JBON.js";
import {
  __spreadValues
} from "./4BKCJXBM.js";

// src/collection/collection-store.ts
import * as Core from "@ariakit/core/collection/collection-store";
function useCollectionStoreOptions(_props) {
  return {};
}
function useCollectionStoreProps(store, props) {
  useStoreProps(store, props, "items", "setItems");
  return store;
}
function useCollectionStore(props = {}) {
  const options = useCollectionStoreOptions(props);
  const store = useStore(
    () => Core.createCollectionStore(__spreadValues(__spreadValues({}, props), options))
  );
  return useCollectionStoreProps(store, props);
}

export {
  useCollectionStoreOptions,
  useCollectionStoreProps,
  useCollectionStore
};
